import request from './index'

export const authApi = {
  register: (data) => request.post('/auth/register', data),
  login: (data) => request.post('/auth/login', data),
  refreshSubscription: (rememberMe = false) => request.post('/auth/refresh-subscription', { rememberMe }),
  getMe: () => request.get('/auth/me'),
  changePassword: (data) => request.put('/auth/change-password', data),
  registerDevice: (data) => request.post('/auth/register-device', data),
  unregisterDevice: (data) => request.post('/auth/unregister-device', data)
}
